import React from 'react';
import { Message as MessageType } from '../utils/types';
import Message from './Message';
import AppIcon from "../utils/AppIcon";

interface MessageGroupProps {
    messages: MessageType[];
    conversationId: number;
    toggleMessageExpansion: (conversationId: number, messageId: number) => void;
    isLoading: boolean;
}

const MessageGroup: React.FC<MessageGroupProps> = ({
                                                       messages,
                                                       conversationId,
                                                       toggleMessageExpansion,
                                                       isLoading
                                                   }) => {
    const questionMessage = messages.find(m => m.type === 'question');
    const answerMessage = messages.find(m => m.type === 'answer');

    const handleToggleExpansion = (messageId: number) => {
        toggleMessageExpansion(conversationId, messageId);
    };

    return (
        <div
            id={`question-${questionMessage?.id}`}
            className="mb-8 bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden"
        >
            {questionMessage && (
                <Message
                    message={questionMessage}
                />
            )}

            {answerMessage ? (
                <Message
                    message={answerMessage}
                />
            ) : (
                isLoading && (
                    <div className="flex p-4">
                        <div className="flex-shrink-0 mr-3">
                            <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600">
                                <AppIcon name="alex_ai_bot" size={32} />
                            </div>
                        </div>
                        <div className="flex-1">
                            <div className="animate-pulse flex space-x-2 items-center">
                                <div className="h-2 w-2 bg-gray-400 rounded-full"></div>
                                <div className="h-2 w-2 bg-gray-400 rounded-full"></div>
                                <div className="h-2 w-2 bg-gray-400 rounded-full"></div>
                                <span className="text-sm text-gray-500">Generating response...</span>
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

export default MessageGroup;